import { render, staticRenderFns } from "./BlogsView.vue?vue&type=template&id=f92a5e8c&scoped=true&"
import script from "./BlogsView.vue?vue&type=script&lang=js&"
export * from "./BlogsView.vue?vue&type=script&lang=js&"
import style0 from "./BlogsView.vue?vue&type=style&index=0&id=f92a5e8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92a5e8c",
  null
  
)

export default component.exports